import createReducer from '../../../../../../../helpers/createReducer';
import { updateGuestSummaryReportSearchQuery } from '../../../../../actions/reports/guest-summary';

const initialState = {
  dateRange: [],
  inventoryLocationId: [],
  trackingMethodId: [],
  groupBy: []
};

const updateGuestSummaryReportSearchQueryHandler = action => ({
  [action.toString()]: (_, { payload: searchQuery }) => searchQuery
});

export default createReducer(initialState, {
  ...updateGuestSummaryReportSearchQueryHandler(
    updateGuestSummaryReportSearchQuery
  )
});
